var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tabs"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('li', {
      key: index,
      staticClass: "nav-item"
    }, [_c('router-link', {
      staticClass: "nav-link",
      class: {
        active: _vm.isCurrentRoute(tab.routeName)
      },
      attrs: {
        "tag": "a",
        "to": {
          name: tab.routeName
        }
      }
    }, [_c('i', [_vm._v(" " + _vm._s(tab.name) + " ")])])], 1);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }